<nav
  class="sticky-bar"
  aria-label="Main navigation"
  [class.sticky-bar--visible]="visible()"
  [attr.inert]="visible() ? null : true"
>
  <div class="sticky-bar__inner">
    <img src="profile-picture-leesey.jpg" alt="" class="sticky-bar__avatar" />
    <span class="sticky-bar__username"><span class="sticky-bar__at">&#64;</span>leesey.reviews</span>
    <span class="sticky-bar__spacer"></span>
    @for (item of items; track item.path) {
      <a
        class="sticky-bar__tab"
        [routerLink]="item.path"
        routerLinkActive="sticky-bar__tab--active"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        {{ item.label }}
      </a>
    }
  </div>
</nav>
